import { v4 as uuidv4 } from 'uuid';
import { assignPublisherColors } from '../../../../commons/utils/publisherColors';
import { normalizePublicPublishers } from './normalizePublicPublisher';
import { getFeaturedPublishersAPI } from './api';

const FEATURED_LIMIT = 6;

async function getFeaturedPublishers() {
    this.observed.featuredPublishersLoading = true;
    try {
        const session = this.env.session;
        const traceId = this.env.traceId;

        const res = await getFeaturedPublishersAPI({ token: session?.token, traceId });
        const data = res?.data?.data || res?.data || null;
        const publishers = data?.publishers || [];

        this.featuredPublishers = assignPublisherColors(normalizePublicPublishers(publishers)).slice(0, FEATURED_LIMIT);
        this.observed.featuredPublishers = uuidv4();
    } finally {
        this.observed.featuredPublishersLoading = false;
    }
}

export default getFeaturedPublishers;
